import DatePicker from "react-datepicker";
import FieldValidationError from "./FieldValidationError";
import "react-datepicker/dist/react-datepicker.css";

const InputDateTime = (props) => {
    return (
        <>
            <DatePicker 
                className="form-control" 
                {...props} 
                dateFormat="dd/MM/yyyy HH:mm"
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="Horário"
            />
            <FieldValidationError error={props.error} />
        </>
    );
};

export default InputDateTime;